import React from 'react';
import styles from "./BulletList.module.scss"; //TODO - change to ol/li semanatics

export function BulletList(_ref) {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, React.Children.map(children, (child, i) => /*#__PURE__*/React.createElement("div", {
    className: styles.bulletRow,
    key: i
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.bullet
  }, i + 1), /*#__PURE__*/React.createElement("span", null, child))));
}